import { cmsPortalUrls } from '../../constants/AppConstants';
import Operate5 from '../../assets/icons/migrate-icon5.svg';
import Operate6 from '../../assets/icons/migrate-icon6.svg';
import Operate1 from '../../assets/icons/operate-icon1.svg';
import Operate2 from '../../assets/icons/operate-icon2.svg';
import Operate3 from '../../assets/icons/operate-icon3.svg';
import Operate4 from '../../assets/icons/operate-icon4.svg';
import AvgCPUChart from '../../assets/images/AVGCPU.jpg';
import HTTPSStatusCodeChart from '../../assets/images/AVGCPU.jpg';
import TotalCPUChart from '../../assets/images/TotalCPU.jpg';
import { SiteReliabilitySection } from '../../libs/models/DashboardModels';
import { IRealibilityMetricsCardData } from './ReliabilityMetric/ReliabilityMetric';

export const OperateLabels = {
  enable: 'Enable',
  title: 'Operate',
  subtitle1: '(To launch the CMS/OpenCloud)',
  subtitle:
    'Through discovery, dependency mapping, and risk assessments based on current usage, as well as migration analysis, Cloud Discovery & Assessment enables migrations to be conducted according to informed decisions, helping to minimize risks while ensuring business continuity throughout and after cloud migration.',
};

export interface ICmsDrawerType {
  title: string;
  cmsType: CmsType;
  popoverContent: string;
  cmsRedirectLink?: string;
  icon: string;
}

export enum CmsType {
  OVERALL = 'OVERALL',
  SLA = 'SLA',
  OLA = 'OLA',
  ENV_HEALTH = 'ENV_HEALTH',
  HISTORIC_TREND = 'HISTORIC_TREND',
  VM_INVENTORY = 'VM_INVENTORY',
  SECURITY_COMPLIANCE = 'SECURITY_COMPLIANCE',
  CLOUD_FINANCIAL = 'CLOUD_FINANCIAL',
  DATA_DOG = 'DATA_DOG',
}

export const OperateList: ICmsDrawerType[] = [
  {
    title: 'Overall Analytics',
    cmsType: CmsType.OVERALL,
    cmsRedirectLink: cmsPortalUrls,
    icon: Operate1,
    popoverContent:
      "Overall Analytics gives a bird's eye view of the health, security & compliance status and ticket status for your infrastrucutre",
  },
  // {
  //   title: 'Availability SLAs',
  //   cmsType: CmsType.SLA,
  //   cmsRedirectLink: cmsPortalUrls + 'service',
  //   icon: process.env.PUBLIC_URL + '/availablitysla.svg',
  //   popoverContent:
  //     'The availability SLA reflects system’s ability to automatically handle disruptive events that periodically occur in every region.',
  // },
  // {
  //   title: 'Observability',
  //   cmsType: CmsType.DATA_DOG,
  //   icon: Operate5,
  //   cmsRedirectLink: cmsPortalUrls + 'infra-monitoring',
  //   popoverContent:
  //     'visually track, analyze, and display key performance metrics, which enable you to monitor the health of your infrastructure',
  // },
  // {
  //   title: 'Infrastructure OLAs',
  //   cmsType: CmsType.OLA,
  //   icon: Operate2,
  //   // cmsRedirectLink: cmsPortalUrls + 'infra-monitoring',
  //   popoverContent:
  //     'The OLAs would be used to track internal service commitments such as response time for incidents or problems assigned to IT groups, Availability of servers supporting various applications.',
  // },
  {
    title: 'Observability - Security',
    cmsType: CmsType.ENV_HEALTH,
    icon: Operate3,
    cmsRedirectLink: cmsPortalUrls + 'security',
    popoverContent: 'It gives the compliance status of the VM created.',
  },
  {
    title: 'Observability - Inventory',
    cmsType: CmsType.VM_INVENTORY,
    icon: process.env.PUBLIC_URL + '/cloudinventory.svg',
    cmsRedirectLink: cmsPortalUrls + 'vm-inventory',
    popoverContent:
      'Cloud Asset Inventory inventory is a collection of virtual and physical objects on which you can place permissions, monitor tasks and events, and set alarms',
  },
  {
    title: 'Cloud Spends',
    cmsType: CmsType.CLOUD_FINANCIAL,
    icon: process.env.PUBLIC_URL + '/CloudFinancials.svg',
    popoverContent:
      'Cloud Spends is the process of identifying, measuring, monitoring, and optimizing cloud costs. It consists of procedures and tools that enable organizations to manage their cloud spend',
  },
  {
    title: 'Observability – CMDB',
    cmsType: CmsType.DATA_DOG,
    icon: process.env.PUBLIC_URL + '/datadog.svg',
    popoverContent:
      'Historical trend displays the trends for the selected application or message family or services for the last 24 hours, last week, last 3 months, or last year.',
  },

  // {
  //   title: 'Security & Compliance',
  //   cmsType: CmsType.SECURITY_COMPLIANCE,
  //   icon: Operate6,
  //   cmsRedirectLink: cmsPortalUrls + 'security',
  //   popoverContent:
  //     ' Track the security threat and compliance status of the environment provisioned',
  // },
];

export const CMSRedirectLink = 'https://deloitteauthqa.opencloudportal.com/';

export const SiteReliabilityMenu: SiteReliabilitySection[] = [
  SiteReliabilitySection.OBSERVABILITY,
  SiteReliabilitySection.CHAOS_ENGINEERING,
  SiteReliabilitySection.SITE_RELIABILITY,
];

// export const SREStaticCards = [
//   {
//     title: 'Average CPU Metrics in ECS Cluster',
//     description:
//       'Average CPU Metrics in ECS Cluster Lörem ipsum krotigt. Ditist trening. Avis nitt inte vängar tranud, i plangen för nogt. Sygen pyre. Fäd beska.Average CPU Metrics in ECS Cluster Lörem ipsum krotigt. Ditist trening. Avis nitt inte vängar tranud, i plangen för nogt. Sygen pyre. Fäd beska.',
//     chart: AvgCPUChart,
//   },
//   {
//     title: 'Total CPU usage ',
//     description:
//       'Total CPU usage in seconds for a specific container or task in an ECS Average CPU Metrics in ECS Cluster Lörem ipsum krotigt. Ditist trening. Avis nitt inte vängar tranud, i plangen för nogt. Sygen pyre. FTotal CPU usage in seconds for a specific container or task in an ECS',
//     chart: TotalCPUChart,
//   },
//   {
//     title: 'HTTP status code returned by an HTTP probe request',
//     description:
//       'Total CPU usage in seconds for a specific container or task in an ECS Average CPU Metrics in ECS Cluster Lörem ipsum krotigt. Ditist trening. Avis nitt inte vängar tranud, i plangen för nogt. Sygen pyre. FTotal CPU usage in seconds for a specific container or task in an ECS',
//     chart: HTTPSStatusCodeChart,
//   },
// ];


export const workloadsForRM: IRealibilityMetricsCardData[] = [
  {
    key: '1',
    name: 'Availability SLAs',
    image: 'cpu_util.svg',
    isRedirectUrlPresent: false,
    isIframeUrlPresent: true,
    link: 'https://deloitteauthqa.opencloudportal.com/service',
    img: '',
  },
  {
    key: '2',
    name: 'Infrastructure OLAs',
    image: 'infra_olas.svg',
    isRedirectUrlPresent: false,
    isIframeUrlPresent: true,
    link: 'https://deloitteauthqa.opencloudportal.com/infra-monitoring',
    img: '',
  },
  {
    key: '2',
    name: 'AWS CloudWatch Logs/ Pet_Clinic_App_1',
    image: 'cpu_util.svg',
    isRedirectUrlPresent: true,
    isIframeUrlPresent: false,
    link: 'https://us-east-1.console.aws.amazon.com/cloudwatch/home?region=us-east-1#home:dashboards/ECS?~(timeRange~43200000)',
    img: '',
  },
  {
    key: '2',
    name: 'AWS CloudWatch Dashboard/ Gen AI Application_1',
    image: 'incoming_bytes.svg',
    isRedirectUrlPresent: true,
    isIframeUrlPresent: false,
    link: 'https://us-east-1.console.aws.amazon.com/cloudwatch/home?region=us-east-1#home:dashboards/ECS?~(timeRange~43200000)',
    img: '',
  },
  {
    key: '11',
    name: 'AWS ECS Dashboard / Pet Clinic Application_1',
    image: 'cpu_metric_ECS_cluster.svg',
    isRedirectUrlPresent: true,
    isIframeUrlPresent: false,
    link: 'http://grafana.dca.deloitte.com/goto/_ZcyJu9IR?orgId=1',
    img: ''
  },
  {
    key: '12',
    name: 'AWS ECS Dashboard / Gen AI Application_1',
    image: 'cpu_util.svg',
    isRedirectUrlPresent: true,
    isIframeUrlPresent: false,
    link: 'http://grafana.dca.deloitte.com/goto/_ZcyJu9IR?orgId=1',
    img: ''
  },
  {
    key: '13',
    name: 'AWS ECS Dashboard/ Pet_Clinic_App_2',
    image: 'database_connections.svg',
    isRedirectUrlPresent: true,
    isIframeUrlPresent: false,
    link: 'http://grafana.dca.deloitte.com/goto/_ZcyJu9IR?orgId=1',
    img: ''
  },
  {
    key: '14',
    name: 'AWS ECS Dashboard/ Gen_AI_Application_2',
    image: 'ebs_volume_ops.svg',
    isRedirectUrlPresent: true,
    isIframeUrlPresent: false,
    link: 'http://grafana.dca.deloitte.com/goto/_ZcyJu9IR?orgId=1',
    img: ''
  },
];
